import type { ReactNode } from 'react';
import { AppstoreOutlined } from '@ant-design/icons';
import { EmptyState } from '@/components/EmptyState';
import { useModuleEnabled } from './useModules';

/**
 * In place of the routed pages when OneLattice is off for this tenant. It waits for a definite no: a failed
 * read leaves the pages to show their own state, since the API refuses whatever is really off.
 */
export function ModuleOffGuard({ children }: { children: ReactNode }) {
  const enabled = useModuleEnabled('onelattice');
  if (enabled === false) {
    return (
      <EmptyState
        icon={<AppstoreOutlined />}
        title="OneLattice is not enabled for this tenant"
        description="The other modules on this tenant keep running. Contact your KYC Hub administrator to add this one."
      />
    );
  }
  return <>{children}</>;
}
